import {
  APIOperationType,
  ProposalsAggregationFieldValueType,
  ProposalsAggregationMethodType,
} from '@blk/aw-bff-typescript-models';

export const AW_PORTFOLIO_MANAGEMENT_API_URL =
  process.env?.AWAPI_AWPORTFOLIOMANAGEMENT_URL || '/api/wealth/portfolio-management';

export const API_OPREATION_TYPE: Record<APIOperationType, APIOperationType> = {
  LOGICAL_OPERATOR_AND: 'LOGICAL_OPERATOR_AND',
  LOGICAL_OPERATOR_OR: 'LOGICAL_OPERATOR_OR',
  LOGICAL_OPERATOR_UNSPECIFIED: 'LOGICAL_OPERATOR_UNSPECIFIED',
};

export const AGGREGATION_METHOD_TYPE: Record<ProposalsAggregationMethodType, ProposalsAggregationMethodType> = {
  AGGREGATION_STATISTIC_FUNCTION_UNSPECIFIED: 'AGGREGATION_STATISTIC_FUNCTION_UNSPECIFIED',
  AGGREGATION_STATISTIC_FUNCTION_AVERAGE: 'AGGREGATION_STATISTIC_FUNCTION_AVERAGE',
  AGGREGATION_STATISTIC_FUNCTION_WEIGHTED_AVERAGE: 'AGGREGATION_STATISTIC_FUNCTION_WEIGHTED_AVERAGE',
  AGGREGATION_STATISTIC_FUNCTION_STANDARD_DEVIATION: 'AGGREGATION_STATISTIC_FUNCTION_STANDARD_DEVIATION',
  AGGREGATION_STATISTIC_FUNCTION_SUM: 'AGGREGATION_STATISTIC_FUNCTION_SUM',
  AGGREGATION_STATISTIC_FUNCTION_COUNT_FALSE: 'AGGREGATION_STATISTIC_FUNCTION_COUNT_FALSE',
  AGGREGATION_STATISTIC_FUNCTION_COUNT_DISTINCT: 'AGGREGATION_STATISTIC_FUNCTION_COUNT_DISTINCT',
  AGGREGATION_STATISTIC_FUNCTION_COUNT: 'AGGREGATION_STATISTIC_FUNCTION_COUNT',
  AGGREGATION_STATISTIC_FUNCTION_MAX: 'AGGREGATION_STATISTIC_FUNCTION_MAX',
  AGGREGATION_STATISTIC_FUNCTION_MIN: 'AGGREGATION_STATISTIC_FUNCTION_MIN',
};

export const FIELD_VALUE_TYPE: Record<ProposalsAggregationFieldValueType, ProposalsAggregationFieldValueType> = {
  FIELD_VALUE_TYPE_UNSPECIFIED: 'FIELD_VALUE_TYPE_UNSPECIFIED',
  FIELD_VALUE_TYPE_STRING: 'FIELD_VALUE_TYPE_STRING',
  FIELD_VALUE_TYPE_NUMBER: 'FIELD_VALUE_TYPE_NUMBER',
};
